import { InjectionToken } from '@angular/core';

import { ApFileSelectorComponent } from './selector/selector.component';
import { ReadFile } from './read-file.model';

// see https://stackoverflow.com/questions/35789498/new-typescript-1-8-4-build-error-build-property-result-does-not-exist-on-t
export interface FileReaderEventTarget extends EventTarget {
    result: string;
}

export interface FileReaderProgressEvent extends Event {
    target: FileReaderEventTarget;

    getMessage(): string;
}

export enum FileExtensions {
    jpeg = 'jpeg',
    jpg = 'jpg',
    png = 'png',
    gif = 'gif',
    bmp = 'bmp',
    docx = 'docx',
    doc = 'doc',
    pdf = 'pdf'
}

export interface FilesValidator {
    fileSelector: ApFileSelectorComponent;
    showNotification: boolean;
    validate: (previousValue: ReadFile[], currentValue: ReadFile[]) => boolean;
    getNotification: () => NotificationMetadata;
}

export interface NotificationMetadata {
    content: string;
    testId?: string;
    type: 'error' | 'success';
}

export const FILE_VALIDATORS = new InjectionToken<FilesValidator>('FileValidators');
